/* tslint:disable */
/* eslint-disable */
/**
 * Bias Proof License API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImplicitBiasInterpretation {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

export function ImplicitBiasInterpretationFromJSON(json: any): ImplicitBiasInterpretation {
    return ImplicitBiasInterpretationFromJSONTyped(json, false);
}

export function ImplicitBiasInterpretationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImplicitBiasInterpretation {
    return json as ImplicitBiasInterpretation;
}

export function ImplicitBiasInterpretationToJSON(value?: ImplicitBiasInterpretation | null): any {
    return value as any;
}

